<div class="selector-main">
    <div class="lists-row">
        <div class="list-col">
            <div class="list-header">
                <label nz-checkbox [ngModel]="allAvailableChecked()" (ngModelChange)="toggleAllAvailable($event)">Disponíveis</label>
                <span class="list-count">{{dynaServices.availableColumns.length}}</span>
            </div>
            <div class="column-list">
                <label nz-checkbox *ngFor="let item of dynaServices.availableColumns"
                    [ngModel]="availableSelected.has(item.IDCOLUMN)"
                    (ngModelChange)="toggleAvailable(item.IDCOLUMN, $event)">{{item.COLUMNDESC}}</label>
            </div>
        </div>
        <div class="transfer-buttons">
            <button nz-button nzType="primary" nz-tooltip="Adicionar às exibidas" [disabled]="availableSelected.size == 0" (click)="sendColumns('a')">
                <nz-icon nzType="right"></nz-icon>
            </button>
            <button nz-button nz-tooltip="Remover das exibidas" [disabled]="enabledSelected.size == 0" (click)="sendColumns('u')">
                <nz-icon nzType="left"></nz-icon>
            </button>
        </div>
        <div class="list-col">
            <div class="list-header">
                <label nz-checkbox [ngModel]="allEnabledChecked()" (ngModelChange)="toggleAllEnabled($event)">Exibidas</label>
                <span class="list-count">{{dynaServices.enabledColumns.length}}</span>
            </div>
            <div class="column-list">
                <label nz-checkbox *ngFor="let item of dynaServices.enabledColumns"
                    [ngModel]="enabledSelected.has(item.IDCOLUMN)"
                    (ngModelChange)="toggleEnabled(item.IDCOLUMN, $event)">{{item.COLUMNDESC}}</label>
            </div>
        </div>
        <div class="transfer-buttons">
            <button nz-button nz-tooltip="Mover para cima" [disabled]="enabledSelected.size != 1" (click)="orderColumn('u')">
                <nz-icon nzType="up"></nz-icon>
            </button>
            <button nz-button nz-tooltip="Mover para baixo" [disabled]="enabledSelected.size != 1" (click)="orderColumn('d')">
                <nz-icon nzType="down"></nz-icon>
            </button>
        </div>
    </div>
    <div class="btnConfCancel">
        <button nz-button nzType="default" (click)="closeGrid()">Cancelar</button>
        <button nz-button nzType="primary" (click)="confirm()">Aplicar</button>
    </div>
</div>
